import React from 'react';
import '../TermsOfUse.css';

function FAQ() {
    return (
        <div className="terms-of-use">
            <div className="dflex jc-center">
                <div className="w74">
                    <h4>
                        <span>1.</span> What is AZAL-Miles?
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp; AZAL-Miles is the frequent flyer programme of Azerbaijan Airlines. AZAL-Miles programme members can earn travel points and status points by flying on Azerbaijan Airlines and Buta Airways.
                    </h4>
                    <br/>
                    <h4>
                        <span>2.</span> What are travel points?
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp; Travel points can be earned by members whenever they travel with tickets purchased and used on the flights of Azerbaijan Airlines or Buta Airways , and also when using the services of partners. Travel points are earned for every euro (€) of the base fare of the tickets (base fare - is the fare of the ticket excluding taxes and surcharges).
                        <br />
                        Travel points can be used to pay for reward tickets on scheduled flights of Azerbaijan Airlines.
                    </h4>
                    <br />
                    <h4>
                        <span>3.</span> What are status points?
                        <br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;Status points are collected on flights with Azerbaijan Airlines or Buta Airways, they cannot be exchanged for anything. They serve for upgrade/maintain membership statuses. Status points are earned on each flight; the value of status points is based on the destination and the class of travel.
                    </h4>
                    <br/>
                    <h4>
                        <span>4.</span> What are bonus travel points?
                        <br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;Bonus travel points are the extra travel points that you earn once you upgrade from Classic membership to Gold or Platinum. Gold members earn an additional 100% and Platinum members earn an additional 200% of points, these additional points are identified within the membership statement as bonus travel points. These points are exactly the same as travel points; they have the same value and validity.
                    </h4>
                    <br/>
                    <h4>
                        <span>5.</span> Are there flights where I do not receive travel and status points?
                        <br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;You cannot earn points on flights that are operated by other airlines, for charter flights or reward flights.
                    </h4>
                    <br/>
                    <h4>
                        <span>6.</span> How do I qualify for higher levels of membership within the AZAL-Miles programme?
                        <br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;Earning status points in a membership year is the way to upgrade your membership status, the more status points you earn, the higher level of your membership will be.
                    </h4>
                </div>
            </div>
        </div>
    );
};

export default FAQ;